module.exports = __webpack_public_path__ + "assets/icon-conductor-rope8.b61b026c.svg";